import { render, staticRenderFns } from "./StadiumBoostLocalCustomersUpdateFormItems.vue?vue&type=template&id=1bc6a283&"
import script from "./StadiumBoostLocalCustomersUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostLocalCustomersUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc6a283')) {
      api.createRecord('1bc6a283', component.options)
    } else {
      api.reload('1bc6a283', component.options)
    }
    module.hot.accept("./StadiumBoostLocalCustomersUpdateFormItems.vue?vue&type=template&id=1bc6a283&", function () {
      api.rerender('1bc6a283', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumBoostLocalCustomersUpdateFormItems.vue"
export default component.exports